/* projects/speaker-platform/src/app/pages/speaker-planning/speaker-planning.component.scss */
/*# sourceMappingURL=speaker-planning.component-YGOYNOAF.css.map */
